import { useState, useEffect } from 'react'
import { get } from 'aws-amplify/api'

import { RuntimeHistory } from 'types/RuntimeHistory'
import { fetchAuthSession } from 'aws-amplify/auth'

const useServerlessRth = (dealerId, deviceId, startTime, endTime, timeZone, refreshTimestamp) => {
  const [rthData, setRthData] = useState<RuntimeHistory | null>(null)
  const [isRTHDataLoaded, setIsRTHDataLoaded] = useState(false)

  useEffect(() => {
    (async () => {
      setIsRTHDataLoaded(false)
      const session = await fetchAuthSession()

      try {
        const res = await get({
          apiName: 'deviceLookupApi',
          path: `/rth/${deviceId}?startDate=${startTime}&endDate=${endTime}&timezone=${timeZone}`,
          options: {
            headers: { 'DWAAuthorization': session?.tokens?.idToken?.toString() || '' }
          }
        }).response

        const rth = await res.body.json()

        setRthData(rth as unknown as RuntimeHistory)
      } catch (_error) { // eslint-disable-line @typescript-eslint/no-unused-vars
      } finally {
        setIsRTHDataLoaded(true)
      }
    })()
  }, [deviceId, dealerId, startTime, endTime, timeZone, refreshTimestamp])

  return { rthData, isRTHDataLoaded }
}

export default useServerlessRth
